// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__aCfgk","label":"Radio_label__1uGol","checkMark":"Radio_checkMark__Upr7t","disabled":"Radio_disabled__38RNC"};